import React from 'react';
import loadable from '@loadable/component';
import Loader from 'components/Loader';

const BookingFinancials = loadable(() => import(/* webpackChunkName: "BookingFinancials" */ './Financials'), {
  fallback: <Loader visible />,
});

export default BookingFinancials;
